import React, { useContext } from "react";
import ListCard from "./components/servers-card/servers-list.container";
import CardComponent from "./components/servers-card/servers-card.component";
import {
    CardTitle,
    MainStructure,
    MainContainer,
    CardContent,
} from "../../components/layout";
import { I8nContext } from "../../../../../libs/i18n";
import DasboardHeader from "../../../../providers/header";
import styled from "styled-components";

const CustomCardContent = styled(CardContent)`
    width: 90vw;
    height: 90vh;
`;

const ServersSummaryDashboard: React.FC = () => {
    const { translate } = useContext(I8nContext);

    return (
        <MainStructure>
            <DasboardHeader
                title={translate("SERVICE_SUMMARY")}
                selector={null}
                withRating={false}
                withScoreBoard={false}
            />
            <MainContainer>
                <div>
                    <CardTitle>
                        <p style={{ width: "30%" }}>{translate("SERVICE")}</p>
                        <p style={{ width: "15%" }}>{translate("GUEST_COUNT")}</p>
                        <p style={{ width: "20%" }}>{translate("AVG_TICKET")}</p>
                        <p style={{ width: "20%"}}>{translate("TOTAL_SALES")}</p>
                        <p style={{ width: "15%" }}>{translate("RATING")}</p>
                    </CardTitle>
                    <CustomCardContent>
                        <ListCard Component={CardComponent} />{" "}
                    </CustomCardContent>
                </div>
            </MainContainer>
        </MainStructure>
    );
};

export default ServersSummaryDashboard;
